import { merge as _merge } from 'lodash'
import ja from 'core/translations/ja'

export default _merge(ja, {})
